import React from "react";
import {
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import HandshakeIcon from "@mui/icons-material/Handshake";
import GroupsIcon from "@mui/icons-material/Groups";
import BusinessIcon from "@mui/icons-material/Business";
import { useTranslation } from "react-i18next";
import GroupCompanyMercue from "./GroupCompanyMercue";
import BgTitle from "components/title/BgTitle";

export default ({ companyUrls }) => {
  const { t } = useTranslation();
  const defaultPlans = t("subcompany_plans", { returnObjects: true });

  const getPlanIcon = (index) => {
    switch (index) {
      case 0:
        return <HandshakeIcon />;
      case 1:
        return <GroupsIcon />;
      case 2:
        return <BusinessIcon />;
      default:
        return <BusinessIcon />;
    }
  };

  return (
    <Box sx={{ pb: 4 }}>
      {/* Header Section */}
      <Box sx={{ px: 2, py: 4, textAlign: "center" }}>
        <BgTitle text={t("subcompany_profile_title")} isCenter={true} />
        <Box
          sx={{
            borderLeft: "4px solid",
            borderColor: "primary.main",
            p: 2,
            mt: 2,
            bgcolor: "#f5f5f5",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              lineHeight: 1.6,
              fontSize: "0.8rem",
            }}
          >
            {t("subcompany_profile_sub")}
          </Typography>
        </Box>
      </Box>

      {/* Plans Section */}
      <Box sx={{ px: 2 }}>
        {Object.keys(defaultPlans).map((key, index) => {
          const plan = defaultPlans[key];
          return (
            <Box
              key={index}
              sx={{
                mb: 3,
                position: "relative",
                borderRadius: 4,
                overflow: "hidden",
                bgcolor: plan.featured ? "primary.main" : "background.paper",
                boxShadow: (theme) =>
                  plan.featured
                    ? `0 8px 32px ${theme.palette.primary.main}20`
                    : "0 4px 12px rgba(0,0,0,0.05)",
              }}
            >
              {/* Plan Header */}
              <Box
                sx={{
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  borderBottom: "1px solid",
                  borderColor: plan.featured ? "primary.dark" : "divider",
                }}
              >
                <IconButton
                  sx={{
                    mr: 2,
                    bgcolor: plan.featured ? "primary.dark" : "primary.lighter",
                    color: plan.featured ? "white" : "primary.main",
                  }}
                >
                  {getPlanIcon(index)}
                </IconButton>
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 650,
                      fontSize: "0.8rem",
                      color: plan.featured ? "white" : "text.primary",
                    }}
                  >
                    {plan.name}
                  </Typography>
                </Box>
              </Box>

              {/* Features List */}
              <List sx={{ p: 0 }}>
                {plan.features.map((feature, idx) => (
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    style={
                      !companyUrls[index][idx] ? { pointerEvents: "none" } : {}
                    }
                    key={idx}
                    href={companyUrls[index][idx]}
                  >
                    <ListItem
                      key={idx}
                      sx={{
                        borderBottom:
                          idx !== plan.features.length - 1
                            ? "1px solid"
                            : "none",
                        borderColor: plan.featured ? "primary.dark" : "divider",
                        py: 2,
                      }}
                    >
                      <ListItemText
                        primary={feature}
                        sx={{
                          "& .MuiListItemText-primary": {
                            color: plan.featured ? "white" : "text.primary",
                            fontSize: "0.7rem",
                            fontWeight: 500,
                          },
                        }}
                      />
                      {companyUrls[index][idx] && (
                        <i className="fa-solid fa-arrow-up-right-from-square"></i>
                      )}
                    </ListItem>
                  </a>
                ))}
              </List>
            </Box>
          );
        })}
      </Box>
      <GroupCompanyMercue />
    </Box>
  );
};
